import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'
 
import VForm17Toggle from './VForm17Toggle.vue' 
registerVueComponentAndAngularBindings('vform17_toggle:component', 'vform17Toggle', VForm17Toggle)